import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { AutoComplete } from '@matillion/component-library'

import classes from './ConflictVersionSelector.module.scss'
import {
  type ConflictVersion,
  type ConflictVersionSelectorProps
} from './types'
import { type AutoCompleteHandler } from '../BranchSelector/types'

const ConflictVersionSelector = ({
  version,
  onSelect
}: ConflictVersionSelectorProps) => {
  const { t } = useTranslation()

  const handleSelect = useCallback<AutoCompleteHandler>(
    ({ target: { value } }) => {
      onSelect((value?.id as ConflictVersion) ?? 'NOT_SELECTED')
    },
    [onSelect]
  )

  return (
    <AutoComplete
      value={version}
      allowFreetext={false}
      onChange={handleSelect}
      className={classes.Selector}
      data-testid="conflict-version-selector"
      placeholder={t('merge.version.placeholder')}
      availableItems={[
        { id: 'OURS', name: t('merge.version.ours') },
        { id: 'THEIRS', name: t('merge.version.theirs') }
      ]}
    />
  )
}

export default ConflictVersionSelector
